import type { FechamentoItem } from "../../../services/historicoFechamentos"

export type HistoricoFechamentosModel = {
    fechamentos: FechamentoItem[]
}

export const HistoricoFechamentosInicial: HistoricoFechamentosModel = {
    fechamentos: [],
}
